import TopicTableContainer from './TopicTableContainer';
import TopicListData from "./services/TopicListData";
import stores from './stores';

const TopicTable = {
  path: [`/topics/`],
  exact: false,
  services: [new TopicListData()],
  stores: stores,
  component: TopicTableContainer,
};

export default TopicTable;